import { useDisclosure } from "@/hooks";
import { useGetAddNewMeditator } from "@/hooks/query-hooks/useMeditators";
import { Button, Form, Modal } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { MeditatorForm } from "./MeditatorForm";

export function AddNewMeditator() {

    const [opened, { toggle }] = useDisclosure();

    const { mutate, isLoading: isAdding } = useGetAddNewMeditator();

    const [form] = Form.useForm();
    const onSubmit = (data: AddNewMeditatorRequest) => {
        mutate(data, {
            onSuccess: () => {
                onCloseModal();
            }
        })
    }

    const onCloseModal = () => {
        toggle();
        form.resetFields();
    }

    return (
        <>
            <Button
                icon={<AiOutlinePlus />}
                onClick={toggle}
                type="primary"
                shape="circle"
                size="large"
                className="bg-primary-gradient"
            />
            <Modal
                open={opened}
                onCancel={onCloseModal}
                title="ယောဂီအသစ် စာရင်းသွင်းရန်"
                centered
                width={740}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                destroyOnClose
                okButtonProps={{
                    type: "primary",
                    htmlType: "submit",
                    form: "add-new-meditator-form",
                    className: "bg-primary-gradient",
                    size: "large",
                    shape: "round",
                    loading: isAdding,
                }}
                cancelButtonProps={{
                    type: "text",
                    onClick: onCloseModal,
                    size: "large",
                    disabled: isAdding,
                }}
                maskClosable={false}
            >
                <MeditatorForm
                    form={form}
                    formName="add-new-meditator-form"
                    onSubmit={onSubmit}
                />
            </Modal>
        </>
    );
}
